import { render, staticRenderFns } from "./ComprasManutencaoPrecoFornecedor.vue?vue&type=template&id=5474c673&scoped=true"
import script from "./ComprasManutencaoPrecoFornecedor.vue?vue&type=script&lang=js"
export * from "./ComprasManutencaoPrecoFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5474c673",
  null
  
)

export default component.exports